<app-edit-company-invoice-card *ngIf="!isWaitingToRedirect" [companyProfile]="config.data?.companyProfile" (dataSaved)="onSaved($event)"></app-edit-company-invoice-card>
<div class="flex flex-col" *ngIf="isWaitingToRedirect">
  //progresssbar intermediate
  <p>{{ 'store.invoiceForm.redirecting' | translate }}</p>
  <p-progressBar *ngIf="isWaitingToRedirect" mode="indeterminate" class="w-full" [style]="{'height': '6px'}"></p-progressBar>
</div>
